import { formatDistanceToNow } from 'date-fns'
import { File, X ,FileText} from 'lucide-react'
import { Badge } from '@deepguide-ai/ui/badge'
import { Button } from '@deepguide-ai/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
 
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@deepguide-ai/ui/dropdown-menu'
import { DocumentContext, EditorContext } from '../ChatThreadManager'


// RFC-069: Support both single and multi-document contexts
export function EditorContextBadge({
  context,
  contexts,
  currentDocId,
  onClearContext,
  onRemoveDoc,
  onClearAll,
}: {
  context?: EditorContext // Legacy single-doc context
  contexts?: DocumentContext[] // RFC-069: Multi-doc contexts
  currentDocId?: string // RFC-069: Which doc is current
  onClearContext?: () => void // Legacy clear handler
  onRemoveDoc?: (docId: string) => void // RFC-069: Remove individual doc
  onClearAll?: () => void // RFC-069: Clear all docs
}) {


  // RFC-069: Multi-document mode
  if (contexts && contexts.length > 0) {

    if (contexts.length === 1) {
      return (
        <div className='h-7 px-2 py-1.5 text-xs flex border hover:bg-accent rounded-full items-center gap-[5px]'>
          <File className='text-muted-foreground h-[14px] w-[14px]' />
          <span className='text-foreground max-w-[160px] truncate'>{contexts[0].topicTitle || 'Untitled'}</span>
          {onRemoveDoc && (
            <Button variant='ghost' size='xxsIcon' className='hover:bg-transparent' onClick={(e) => {
              e.stopPropagation()
              onRemoveDoc(contexts[0].docId)
            }}>
              <X className='h-3.5 w-3.5' />
            </Button>
          )}
        </div>
      )
    }
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant='outline' className='h-7 !px-2 !py-1.5 !rounded-full text-xs  gap-[5px]'>
            <File className='text-muted-foreground h-[14px] w-[14px]' />
            <span className='text-foreground max-w-[160px] truncate'>{contexts[0].topicTitle || 'Untitled'}</span>
            <Badge className='px-1 py-1.5 h-5'>+{contexts.length - 1}</Badge>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className='w-56' align='start'>
          {contexts.map((ctx, index) => {
            if (index === 0) return null
            return (
              <DropdownMenuItem
                className='w-full justify-between gap-1.5 py-1.5 px-1'
                key={ctx.docId}
              >
                <File className='text-muted-foreground h-[14px] w-[14px]' />
              <span className='text-foreground flex-1 truncate text-xs'>{ctx.topicTitle || 'Untitled'}</span>
                {onRemoveDoc && (
                  <Button
                    variant='ghost'
                    size='xxsIcon'
                    onClick={(e) => {
                      e.stopPropagation()
                      onRemoveDoc(ctx.docId)
                    }}
                    title='Remove this document from conversation'
                  >
                     <X className='h-3.5 w-3.5' />
                  </Button>
                )}
              </DropdownMenuItem>
            )
          })}
        </DropdownMenuContent>
      </DropdownMenu>
      // <div className="w-full  px-2 py-1.5">
      //   <div className="flex flex-wrap gap-[5px] hover:bg-accent rounded-md ">
      //     <File className="h-[14px] text-muted-foreground w-[14px]" />
      //     {contexts.map((ctx) => (
      //       <Badge
      //         key={ctx.docId}
      //         variant={ctx.docId === currentDocId ? "default" : "outline"}
      //         className="text-xs flex items-center gap-1"
      //       >
      //         📄 {ctx.topicTitle || 'Untitled'}
      //         {ctx.docId === currentDocId && (
      //           <span className="text-[10px] opacity-70">(current)</span>
      //         )}

      //         {onRemoveDoc && (
      //           <button
      //             className="ml-1 hover:text-destructive transition-colors"
      //             onClick={(e) => {
      //               e.stopPropagation();
      //               onRemoveDoc(ctx.docId);
      //             }}
      //             title="Remove this document from conversation"
      //           >
      //             ×
      //           </button>
      //         )}
      //       </Badge>
      //     ))}

      //     {/* {contexts.length > 1 && onClearAll && (
      //       <Button
      //         variant="ghost"
      //         size="sm"
      //         className="h-6 text-xs px-2"
      //         onClick={onClearAll}
      //         title="Remove all documents from conversation context"
      //       >
      //         Clear all
      //       </Button>
      //     )} */}
      //   </div>
      // </div>
    )
  }


  // Legacy single-document mode (backward compatibility)
  if (!context) return null

  // Handle legacy single context - check if it has the new documents array
  if (context.documents && context.documents.length > 0) {
    // This is actually multi-doc format, render as multi-doc
    return (
      <EditorContextBadge
        contexts={context.documents}
        currentDocId={context.currentDocId}
        onRemoveDoc={onRemoveDoc}
        onClearAll={onClearAll}
      />
    )
  }

  // True legacy single-doc format
  return (
    <div className=' mx-4 mb-4 w-full '>
      <div className='mb-1 flex items-center justify-between'>
        <div className='flex items-center gap-2'>
          <File className='text-muted-foreground h-4 w-4' />
          <span className='text-sm font-medium'>Editor Context</span>
        </div>
        {onClearContext && (
          <Button
            variant='ghost'
            size='xxsIcon'
            onClick={onClearContext}
            title='Clear context'
          >
            <X className='h-3.5 w-3.5' />
          </Button>
        )}
      </div>
      <p className='text-muted-foreground line-clamp-1 max-w-[160px] text-xs'>
        {context.selectedText}
      </p>
      {context.timestamp && (
        <p className='text-muted-foreground mt-1 text-xs'>
          {formatDistanceToNow(context.timestamp, { addSuffix: true })}
        </p>
      )}
    </div>
  )
}
